import React from 'react';
import AnalysisDashboard from '../../components/finance/AnalysisDashboard';

const FinanceAnalysisPage = () => {
  return <AnalysisDashboard />;
};

export default FinanceAnalysisPage;
